// Words and sums shared by the Funding tabs.
export const PROVIDERS = [
  ['intercash', 'InterCash'],
  ['opencp', 'Central Payments'],
  ['mdp', 'MDP'],
  ['zumrails', 'ZumRails'],
  ['luxara', 'Luxara'],
] as const;
export const providerLabel = (p: string | null) => PROVIDERS.find(([k]) => k === p)?.[1] ?? p ?? '—';
export const CURRENCIES = ['USD', 'CAD', 'EUR'];

const ENTRY_LABELS: Record<string, string> = {
  deposit: 'Deposit',
  withdrawal: 'Withdrawal',
  adjustment: 'Correction',
  advance: 'Advance',
  advance_repayment: 'Advance paid back',
  load: 'Card load',
  load_release: 'Load given back',
  unload: 'Card unload',
  reversal: 'Load reversed',
  processor_topup: 'Wire to the processor',
  processor_adjustment: 'Ledger correction',
  write_off: 'Written off',
  write_off_recovery: 'Written-off debt recovered',
};
export const entryLabel = (kind: string) => ENTRY_LABELS[kind] ?? kind.replace(/_/g, ' ');

/** "1240.50" / "-3.00" → cents; the API's money is always two decimals. */
export const cents = (amount: string | null | undefined) => (amount ? Math.round(Number(amount) * 100) : 0);
/** Cents → "1240.50", written like the API's own amounts. */
export const amountOf = (value: number) => `${value < 0 ? '-' : ''}${(Math.abs(value) / 100).toFixed(2)}`;
